import React, { useState, useEffect } from "react";
import axios from "axios";
import { CheckToken } from "../login/AccessToken";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import "./BillingPayment.scss";
// import "./EstimateAddition.scss";
import { Card, Radio, RadioGroup } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useLocation } from "react-router-dom/cjs/react-router-dom";
import SideNavbar from "./SideNavbar";
import { toast } from "react-toastify";
import {
  Grid,
  TextField,
  Button,
  Select,
  MenuItem,
  InputLabel,
  FormControl,
  Typography,
} from "@mui/material";
import { Checkbox, FormControlLabel } from "@mui/material";
// import Icon from "../doctor-console/Utils/Icons";
import { ReactComponent as CalendarIcon } from './DummyIcons/calendar-silhouette 2.svg';

import AddIcon from "@mui/icons-material/Add";
import { displayPatientName } from "../../utils/displayPatientName";

const EstimateAddition = () => {
  const [itemsList, setItemsList] = useState([
    { items: "", quantity: "", price: "", amount: "", category: "services" },
  ]);

  const [subtotal, setSubtotal] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [tax, setTax] = useState(0);
  const [notes, setNotes] = useState("");
  const [estimateList, setEstimateList] = useState([]);
  const [patientId, setPatientId] = useState("");

  const REACT_APP_BACKEND_ROUTE_URL = process.env.REACT_APP_BACKEND_ROUTE_URL;
  const [patientList, setPatientList] = useState([]);
  const [services, setServices] = useState([]);
  const [maxEstimateNumber, setMaxEstimateNumber] = useState("");
  const [fillExpiryDate, setFillExpiryDate] = useState(false);
  const [estimateDate, setEstimateDate] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("services");
  const [servicesList, setServicesList] = useState([]);
  const [productsList, setProductsList] = useState([]);

  const handleEstimateDateChange = (event) => {
    setEstimateDate(event.target.value);
  };

  const [authToken, setAuthToken] = useState(
    sessionStorage.getItem("accessToken") !== undefined &&
      sessionStorage.getItem("accessToken") !== null
      ? sessionStorage.getItem("accessToken")
      : ""
  );
  const [facilityName, setFacilityName] = useState(
    sessionStorage.getItem("facility_name") || ""
  );
  const today = new Date().toISOString().split("T")[0];
  const history = useHistory();
  const headers = {
    Authorization: `Bearer ${authToken}`,
  };
  const location = useLocation();
  const { selectedDoctors, selectedServiceRequests, aabhaId, medical_service_ids } =
    location.state || {};

  const Token = () => {
    const check = CheckToken();
    console.log(check);
    setAuthToken(sessionStorage.getItem("accessToken"));
    return check;
  };
  useEffect(() => {
    calculateSubtotal();
  }, []);
  useEffect(() => {
    fetchEstimateList();
  }, []);
  useEffect(() => {
    calculateTotalAmount(); // Recalculate total when subtotal, discount, or tax changes
  }, [subtotal, discount, tax]); // Add this dependency array to watch changes

  // useEffect(() => {
  //   const maxEstimate = getMaxEstimateNumber(estimateList);
  //   setMaxEstimateNumber(maxEstimate);
  // }, [estimateList]);
  useEffect(() => {
    if (
      sessionStorage.getItem("accessToken") == undefined &&
      sessionStorage.getItem("accessToken") == null
    ) {
      history.push("/login");
    }
  }, []);

  useEffect(() => {
    if (authToken !== "") {
      // Fetch services
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_services/`, {
          headers,
        })
        .then((res) => {
          const filteredServices = res.data.service_list.filter(
            (service) => !service.expired && service.active
          );
          setServicesList(filteredServices);
        });

      // Fetch products
      axios
        .get(`${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_products/`, {
          headers,
        })
        .then((res) => {
          const filteredProducts = res.data.product_list.filter(
            (product) => !product.expired && product.active
          );
          setProductsList(filteredProducts);
        });
    }
  }, [authToken]);

  // useEffect(() => {
  //   if (authToken !== "") {
  //     const url =
  //       selectedCategory === "services"
  //         ? `${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_services/`
  //         : `${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_products/`;

  //     axios
  //       .get(url, { headers: headers })
  //       .then((res) => {
  //         const filteredItems =
  //           selectedCategory === "services"
  //             ? res.data.service_list.filter(
  //                 (item) => item.active && !item.expired
  //               )
  //             : res.data.product_list.filter(
  //                 (item) => item.active && !item.expired
  //               );

  //         setServices(filteredItems);

  //         // Prepopulate itemsList if selectedServiceRequests exist
  //       })
  //       .catch((error) => {
  //         console.error(
  //           `Error fetching ${
  //             selectedCategory === "services" ? "services" : "products"
  //           }:`,
  //           error
  //         );
  //       });
  //   }
  // }, [selectedCategory]);

  useEffect(() => {
    if (authToken !== "") {
      axios
        .get(
          `${REACT_APP_BACKEND_ROUTE_URL}get_patient_list_with_aabha_info/`,
          {
            headers: headers,
          }
        )
        .then((res) => {
          setPatientList(res.data?.data);
          if (aabhaId) {
            const selectedPatient = res.data?.data.find(
              (patient) => patient.abha_id === aabhaId
            );
            if (selectedPatient) {
              setPatientId(selectedPatient.patient_id);
            }
          }
        });
    }
  }, [authToken, aabhaId]);

  useEffect(() => {
    if (authToken !== "") {
      const isGetById =
        Array.isArray(medical_service_ids) && medical_service_ids.length > 0;
      const url = isGetById
        ? `${REACT_APP_BACKEND_ROUTE_URL}get_medical_services/`
        : `${REACT_APP_BACKEND_ROUTE_URL}get_all_medical_services/`;

      const request = isGetById
        ? axios.post(
          url,
          { medical_service_ids: medical_service_ids },
          { headers }
        )
        : axios.get(url, { headers });

      request.then((res) => {
        const list = res.data?.service_list || res.data?.data || [];
        const filteredServices = list.filter(
          (service) => !service.expired && service.active
        );

        // Set the filtered services
        setServices(filteredServices);

        // Filter and add matching services to itemsList
        if (selectedServiceRequests && selectedServiceRequests.length > 0) {
          let matchingItems = [];

          if (isGetById) {
            matchingItems = filteredServices.filter((service) =>
              medical_service_ids.includes(service.medical_service_id)
            );
          }

          if (matchingItems.length > 0) {
            const initialItemsList = matchingItems.map((item) => {
              const amount = (item.fee * 1).toFixed(2); // Calculate amount for quantity 1
              return {
                category: "services",
                items: item.medical_service_id,
                quantity: "1", // Default quantity
                price: item.fee.toFixed(2),
                amount: amount,
              };
            });
            setItemsList(initialItemsList);
          }
        }
      });
    }
  }, [authToken, selectedServiceRequests, medical_service_ids]);

  const fetchEstimateList = () => {
    const requestData = {
      hip_id: facilityName,
    };
    if (authToken !== "") {
      axios
        .post(`${REACT_APP_BACKEND_ROUTE_URL}get_all_estimates/`, requestData, {
          headers: { Authorization: `Bearer ${authToken}` },
        })
        .then((res) => {
          const estimatesWithId = res.data.estimates.map((estimate) => ({
            ...estimate,
            id: estimate.estimate_id,
            total: parseFloat(estimate.total_amount).toFixed(2),
          }));

          setEstimateList(estimatesWithId);
        })
        .catch((error) => {
          console.error("Error fetching estimate list:", error);
        });
    }
  };

  const calculateSubtotal = () => {
    const calculatedSubtotal = itemsList.reduce(
      (total, item) => total + parseFloat(item.amount || 0),
      0
    );
    setSubtotal(calculatedSubtotal);
  };
  // const calculateTotalAmount = () => {
  //   const discountedSubtotal = subtotal - (subtotal * discount / 100);
  //   const totalAmount = discountedSubtotal + (discountedSubtotal * tax / 100);
  //   return totalAmount.toFixed(2);
  // };
  const calculateTotalAmount = () => {
    const itemsTotal = itemsList.reduce(
      (total, item) => total + parseFloat(item.amount || 0),
      0
    );
    const discountAmount = itemsTotal * (discount / 100);
    const taxAmount = (itemsTotal - discountAmount) * (tax / 100);
    const totalAmount = itemsTotal + taxAmount - discountAmount;
    return totalAmount.toFixed(2);
  };

  const handleAddItem = () => {
    setItemsList([
      ...itemsList,
      { items: "", quantity: "", price: "", amount: "", category: "services" }, // Default category as "services"
    ]);
  };

  const handleItemChange = (index, field, value) => {
    const updatedItemsList = [...itemsList];
    updatedItemsList[index][field] = value;

    if (field === "category") {
      updatedItemsList[index].category = value;
      updatedItemsList[index].items = "";
      updatedItemsList[index].price = "";
      updatedItemsList[index].amount = "";
    } else if (field === "items") {
      const selectedItems =
        updatedItemsList[index].category === "services"
          ? servicesList
          : productsList;
      const selectedItem = selectedItems.find(
        (item) => item.medical_service_id === value || item.product_id === value
      );
      if (selectedItem) {
        updatedItemsList[index].price = selectedItem.fee.toFixed(2);
        updatedItemsList[index].amount = (
          (parseFloat(updatedItemsList[index].quantity) || 0) * selectedItem.fee
        ).toFixed(2);
      } else {
        updatedItemsList[index].price = "";
        updatedItemsList[index].amount = "";
      }
    } else if (field === "quantity") {
      const price = parseFloat(updatedItemsList[index].price) || 0;
      const quantity = parseFloat(value) || 0;
      updatedItemsList[index].amount = (quantity * price).toFixed(2);
    }

    setItemsList(updatedItemsList);
    calculateSubtotal();
  };

  const handleTotalChange = (field, value) => {
    if (field === "subtotal") {
      setSubtotal(parseFloat(value) || 0);
    } else if (field === "discount") {
      setDiscount(parseFloat(value) || 0);
    } else if (field === "tax") {
      setTax(parseFloat(value) || 0);
    }
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    const filteredItems = itemsList.filter(
      (item) =>
        item.items &&
        item.quantity != null &&
        item.quantity != null &&
        item.quantity !== ""
    );

    // Check if any required item or quantity is not selected
    if (filteredItems.length !== itemsList.length) {
      console.log(filteredItems.length);
      console.log(itemsList.length);
      toast.error("Please select an item and enter the quantity for all rows.");
      return;
    }

    const tot = document.getElementById("totalAmount").value;
    // Validate total_amount
    if (isNaN(tot) || tot <= 0) {
      toast.error("Total amount must be a valid number greater than 0.");
      return;
    }

    const estimateDate = document.getElementById("estimateDate").value;
    const expiryDate = document.getElementById("expiryDate").value;
    // const estimateNumber = document.getElementById("estimateNumber").value;
    const patientId = document.getElementById("patientSelect").value;
    const total = document.getElementById("totalAmount").value;

    if (new Date(expiryDate) < new Date(estimateDate)) {
      toast.error("Expiry date must be after or on the estimate date.");
      return;
    }

    const itemsListWithItemNames = itemsList.map((item) => {
      const combinedList = [...servicesList, ...productsList];

      const selectedService = combinedList.find(
        (service) => service.medical_service_id === item.items
      );
      return {
        ...item,
        itemName: selectedService ? selectedService.name : "",
      };
    });

    const selectedPatient = patientList.find(
      (patient) => patient.patient_id === patientId
    );
    if (!selectedPatient) {
      console.error(
        "Patient details not found for selected patient_id:",
        patientId
      );
      return;
    }
    const patientName = selectedPatient.name;
    console.log("patientName", patientName);

    const requestBody = {
      hip_id: facilityName,
      // estimate_number: estimateNumber,
      total_amount: calculateTotalAmount(),
      estimate_date: estimateDate,
      expiry_date: expiryDate,
      patient_id: patientId,
      items: itemsList.map((item) => ({
        item_id: item.items,
        quantity: parseInt(item.quantity, 10),
      })),
      note: notes,
      discount: discount,
      tax: tax,
    };
    // const estimateData = {
    //   itemsList: itemsListWithItemNames,
    //   subtotal,
    //   discount,
    //   tax,
    //   notes,
    //   estimateDate,
    //   expiryDate,
    //   // estimateNumber,
    //   total,
    //   patientName: patientName,
    // };
    axios
      .post(
        `${REACT_APP_BACKEND_ROUTE_URL}create_estimate/`,
        JSON.stringify(requestBody),
        {
          headers: headers,
        }
      )
      .then((response) => {
        if (response.data.status == "Success") {
          toast.success(response.data.message);
          const estimateData = {
            itemsList: itemsListWithItemNames,
            subtotal,
            discount,
            tax,
            notes,
            estimateDate,
            expiryDate,
            estimateNumber: response.data.estimate_number,
            total,
            patientName: patientName,
          };
          console.log("Estimate submitted successfully:", response.data);
          console.log("Estimate Data", estimateData);
          history.push("/estimatePreview", { estimateData });
        } else {
          toast.error("Error");
        }
      })
      .catch((error) => {
        console.error("Error submitting estimate:", error);
        // Handle errors (e.g., show error message to the user)
      });
  };

  const handleRemoveItem = (indexToRemove) => {
    const updatedItemsList = itemsList.filter(
      (item, index) => index !== indexToRemove
    );
    setItemsList(updatedItemsList);
    calculateSubtotal();
  };

  const handleNotesChange = (value) => {
    setNotes(value);
  };

  const handleGoBack = () => {
    history.push("/doctor/estimates");
  };
  const handleCheckboxChange = (event) => {
    const { checked } = event.target;
    setFillExpiryDate(checked);
    if (checked) {
      const estimateDate = document.getElementById("estimateDate").value;
      document.getElementById("expiryDate").value = estimateDate;
    } else {
      document.getElementById("expiryDate").value = "";
    }
  };

  const getMaxEstimateNumber = (estimateList) => {
    if (estimateList.length === 0) return "EST-001"; // Default if no estimates exist

    const maxEstimate = estimateList.reduce((max, estimate) => {
      const estimateNumber = parseInt(
        estimate.estimate_number.split("-")[1],
        10
      );
      return estimateNumber > max ? estimateNumber : max;
    }, 0);

    return `EST-${(maxEstimate + 1).toString().padStart(3, "0")}`;
  };

  return (
    <>
      <SideNavbar >
        <div className="estimate-addition-wrapper">

          <form onSubmit={handleSubmit}>
            {/* <ArrowBackIcon
            className="back-icon"
            onClick={handleGoBack}
            style={{ cursor: "pointer", margin: "10px" }}
          /> */}

            <Card
              sx={{
                borderRadius: "8px",
                marginBottom: "25px",
                padding: "5px 10px",
                margin: "5px 10px",
              }}
            >
              {/* <ArrowBackIcon
                className="back-icon"
                onClick={handleGoBack}
                style={{ cursor: "pointer", margin: "10px" }}
              /> */}
              <p style={{ fontWeight: "bold", fontSize: "32px", color: "#172935", marginBottom: "16px" }}>Add New Estimates</p>
              <Grid container spacing={2}>
                {/* Left Side (Patient Selection) */}
                <Grid item xs={12} sm={6} md={6}>
                  <div className="form-group">
                    <label htmlFor="patientSelect" className="required-label">
                      Select Patient
                    </label>
                    <select
                      className="form-control"
                      id="patientSelect"
                      name="patientSelect"
                      required
                      value={patientId}
                      onChange={(e) => setPatientId(e.target.value)}
                    >
                      <option value="">Select Patient</option>
                      {patientList.map((patient) => (
                        <option key={patient.patient_id} value={patient.patient_id}>
                          {displayPatientName(patient.name)}
                        </option>
                      ))}
                    </select>
                  </div>
                </Grid>

                {/* Right Side (Other Fields) */}
                <Grid item xs={12} sm={6} md={6}>
                  <Grid container spacing={2}>
                    {/* Estimate Date */}
                    <Grid item xs={12} sm={6} md={6}>
                      <div className="input-wrapper">
                        <label htmlFor="estimateDate" className="required-label">
                          <span>Estimate Date</span>
                        </label>
                        <div className="date-input-container" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                          <input
                            type="date"
                            className="form-control date-input"
                            id="estimateDate"
                            name="estimateDate"
                            required
                            min={today}
                            max="2050-01-01"
                            onChange={handleEstimateDateChange}
                            style={{ paddingRight: '2.5rem' }}
                          />
                          <i
                            style={{
                              position: 'absolute',
                              right: '0.75rem',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                            }}
                          >
                            <CalendarIcon
                              onClick={() =>
                                document.getElementById("estimateDate").showPicker?.()
                              }
                            />
                          </i>
                        </div>
                      </div>
                    </Grid>

                    {/* Expiry Date */}
                    <Grid item xs={12} sm={6} md={6}>
                      <div className="input-wrapper">
                        <label htmlFor="expiryDate" className="required-label date-label">
                          Expiry Date
                        </label>
                        <div className="date-input-container" style={{ position: 'relative', display: 'flex', alignItems: 'center' }}>
                          <input
                            type="date"
                            className="form-control"
                            id="expiryDate"
                            name="expiryDate"
                            required
                            min={today}
                            max="2050-01-01"
                            style={{ paddingRight: '2.5rem' }}
                          />
                          <i
                            style={{
                              position: 'absolute',
                              right: '0.75rem',
                              top: '50%',
                              transform: 'translateY(-50%)',
                              cursor: 'pointer',
                            }}
                          >
                            <CalendarIcon
                              onClick={() =>
                                document.getElementById("expiryDate").showPicker?.()
                              }
                            />
                          </i>
                        </div>
                      </div>
                      <Grid item xs={12}>
                        <FormControlLabel
                          control={
                            <Checkbox
                              id="fillExpiryDate"
                              name="fillExpiryDate"
                              checked={fillExpiryDate}
                              onChange={handleCheckboxChange}
                              disabled={!estimateDate}
                            />
                          }
                          label="Same as Estimate Date"
                        /></Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Card>

            <Card
              sx={{
                borderRadius: "8px",
                marginBottom: "25px",
                padding: "15px",
                margin: "5px 10px",
                boxShadow: "0px 2px 4px rgba(0,0,0,0.05)"
              }}
            >
              {itemsList.map((item, index) => (
                <Grid
                  container
                  spacing={2}
                  key={index}
                  sx={{
                    mb: 1,
                    p: 2,
                    borderRadius: "8px",
                    backgroundColor: "#E9F5FE", // Restoring the light blue background requested earlier
                    alignItems: "center"
                  }}
                >
                  {/* Category Selection */}
                  <Grid item xs={12} sm={6} md={2}>
                    <RadioGroup
                      row
                      value={item.category || "services"}
                      onChange={(e) => handleItemChange(index, "category", e.target.value)}
                    >
                      <FormControlLabel value="services" control={<Radio size="small" />} label="Services" />
                      <FormControlLabel value="products" control={<Radio size="small" />} label="Products" />
                    </RadioGroup>
                  </Grid>

                  {/* Item Selection */}
                  <Grid item xs={12} sm={6} md={3}>
                    <select
                      className="form-control"
                      style={{ borderRadius: "8px", border: "1px solid #ced4da" }}
                      value={item.items}
                      onChange={(e) => {
                        handleItemChange(index, "items", e.target.value);
                      }}
                    >
                      <option value="">Select Item</option>
                      {(item.category === "products" ? productsList : servicesList).map((option) => (
                        <option
                          key={option.medical_service_id || option.product_id}
                          value={option.medical_service_id || option.product_id}
                        >
                          {option.name}
                        </option>
                      ))}
                    </select>
                  </Grid>

                  {/* Quantity Field */}
                  <Grid item xs={12} sm={4} md={2}>
                    <input
                      type="number"
                      className="form-control"
                      style={{ borderRadius: "8px", border: "1px solid #ced4da" }}
                      placeholder="Enter quantity"
                      value={item.quantity}
                      onChange={(e) =>
                        handleItemChange(index, "quantity", e.target.value)
                      }
                      min="0"
                      onWheel={(e) => e.target.blur()}
                      onKeyDown={(e) => {
                        if (e.key === "-" || e.key === "+") {
                          e.preventDefault();
                        }
                      }}
                    />
                  </Grid>

                  {/* Price Field */}
                  <Grid item xs={12} sm={4} md={2}>
                    <input
                      type="text"
                      className="form-control"
                      style={{ borderRadius: "8px", border: "1px solid #ced4da", backgroundColor: "#fff" }}
                      value={item.price}
                      readOnly
                      placeholder="Price"
                    />
                  </Grid>

                  {/* Amount Field */}
                  <Grid item xs={12} sm={4} md={2}>
                    <input
                      type="text"
                      className="form-control"
                      style={{ borderRadius: "8px", border: "1px solid #ced4da", backgroundColor: "#fff" }}
                      value={item.amount}
                      readOnly
                      placeholder="Amount"
                    />
                  </Grid>

                  {/* Action Field */}
                  <Grid item xs={12} sm={12} md={1}>
                    <Button
                      variant="contained"
                      sx={{
                        backgroundColor: "#bdbdbd",
                        color: "white",
                        minWidth: "80px",
                        padding: "6px 12px",
                        fontSize: "12px",
                        fontWeight: "bold",
                        "&:hover": { backgroundColor: "#9e9e9e" }
                      }}
                      onClick={() => handleRemoveItem(index)}
                    >
                      REMOVE
                    </Button>
                  </Grid>
                </Grid>
              ))}

              <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="center"
                style={{ outline: 'none !important', border: 'none !important' }}
              >
                <Grid item xs={12}><center>
                  <button
                    type="button"
                    className="btn btn__secondary btn__rounded btn__block mt-2"
                    // variant="contained"
                    // size="medium"
                    onClick={handleAddItem}
                    style={{
                      color: "white",
                      padding: "8px 16px",
                      width: "25%",
                      // transition: "background-color 0.3s ease",
                      backgroundColor: "#125386",
                      borderRadius: "10px",
                      // boxShadow: "0px 4px 4px 0px #00000040 inset"
                    }}
                  // startIcon={<AddIcon />}
                  >
                    + ADD
                  </button></center>
                </Grid>
              </Grid>
            </Card>
            <Card
              sx={{
                borderRadius: "8px",
                marginBottom: "25px",
                padding: "5px 10px",
                margin: "5px 10px",
              }}>
              {/* <div className="contact-panel"> */}
              {/* <div style={{ outline: 'none', border: 'none' }}> */}
              <Grid container spacing={2}
                alignItems="center"
                justifyContent="center"
                style={{ outline: 'none', border: 'none', boxShadow: 'none' }}>
                {/* Notes Section */}
                <Grid item xs={12} sm={6}>
                  <div style={{ maxWidth: '100%', flexGrow: 1 }}>
                    {/* <label htmlFor="notes">Notes</label> */}
                    <textarea
                      id="notes"
                      name="notes"
                      placeholder="Notes"
                      value={notes}
                      onChange={(e) => handleNotesChange(e.target.value)}
                      style={{
                        width: "100%",
                        height: "247.5px",
                        borderRadius: "2%",
                        // border: '1px solid #ccc',
                        // boxShadow: "0px -3px 4px 0px #00000040 inset",
                        padding: "12px 16px"
                      }}
                      className="responsive-textarea"
                    />
                  </div>
                </Grid>

                {/* Total Section */}
                <Grid
                  item
                  xs={12}
                  sm={5}
                  md={5}
                  lg={4}
                  style={{ marginLeft: "auto" }}
                >
                  <Grid container>
                    {/* Discount Field */}
                    <Grid item xs={12}>
                      <div className="form-group">
                        <label htmlFor="discount" style={{ color: "#808285" }}>Discount(%)</label>
                        <input
                          type="number"
                          className="form-control"
                          id="discount"
                          name="discount"
                          value={discount}
                          onChange={(e) =>
                            handleTotalChange("discount", e.target.value)
                          }
                          onBlur={calculateTotalAmount}
                          min="0"
                          onWheel={(e) => e.target.blur()}
                          onKeyDown={(e) => {
                            if (e.key === "-" || e.key === "+") {
                              e.preventDefault();
                            }
                          }}
                          style={{ width: "100%" }}
                        />
                      </div>
                    </Grid>

                    {/* Tax Field */}
                    <Grid item xs={12}>
                      <div className="form-group">
                        <label htmlFor="tax" style={{ color: "#808285" }}>Add Tax(%)</label>
                        <input
                          type="number"
                          className="form-control"
                          id="tax"
                          name="tax"
                          value={tax}
                          onChange={(e) =>
                            handleTotalChange("tax", e.target.value)
                          }
                          onBlur={calculateTotalAmount}
                          min="0"
                          onWheel={(e) => e.target.blur()}
                          onKeyDown={(e) => {
                            if (e.key === "-" || e.key === "+") {
                              e.preventDefault();
                            }
                          }}
                          style={{ width: "100%" }}
                        />
                      </div>
                    </Grid>

                    {/* Total Amount Field */}
                    <Grid item xs={12}>
                      <div className="form-group">
                        <label htmlFor="totalAmount" style={{ color: "#808285" }}>TOTAL AMOUNT(Rs)</label>
                        <input
                          type="text"
                          className="form-control"
                          id="totalAmount"
                          name="totalAmount"
                          value={calculateTotalAmount()}
                          readOnly
                          style={{ width: "100%" }}
                        />
                      </div>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                container
                spacing={2}
                alignItems="center"
                justifyContent="center"
                style={{ marginTop: "5px", marginBottom: "5px" }}
              >
                <Grid item xs={6}>
                  <center>
                    <button
                      type="submit"
                      // variant="contained"
                      // size="medium"
                      className="btn btn__secondary btn__rounded btn__block mt-2"
                      style={{
                        color: "white",
                        padding: "8px 16px",
                        width: "50%",
                        // transition: "background-color 0.3s ease",
                        backgroundColor: "#125386",
                        borderRadius: "10px",
                        // boxShadow: "0px 4px 4px 0px #00000040 inset"
                      }}
                    >
                      SUBMIT
                    </button></center>
                </Grid>
                <Grid item xs={6}>
                  <center>
                    <button
                      type="button"
                      onClick={handleGoBack}
                      // variant="contained"
                      // size="medium"
                      className="btn btn__secondary btn__rounded btn__block mt-2"
                      style={{
                        color: "white",
                        padding: "8px 16px",
                        width: "50%",
                        // transition: "background-color 0.3s ease",
                        backgroundColor: "#125386",
                        borderRadius: "10px",
                        // boxShadow: "0px 4px 4px 0px #00000040 inset"
                      }}
                    >
                      CANCEL
                    </button></center>
                </Grid>
              </Grid>

              {/* </div>
            </div> */}
            </Card>
          </form>

        </div>
      </SideNavbar>
    </>
  );

};

export default EstimateAddition;